import React from 'react';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = 'Loading chart...' 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 p-8 rounded-2xl bg-neutral-900 border border-neutral-700 shadow-2xl">
        {/* Animated Logo/Spinner */}
        <div className="relative">
          <svg 
            viewBox="-3 -3 63 63" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            className="w-16 h-16 animate-pulse"
          >
            <path 
              d="M33 20.3102V11.3102C33 6.8919 29.4183 3.31018 25 3.31018H11C6.58172 3.31018 3 6.8919 3 11.3102V25.3102C3 29.7285 6.58172 33.3102 11 33.3102H20" 
              stroke="#37A4D3" 
              strokeWidth="6" 
              strokeLinecap="round"
              className="animate-[pulse_1.5s_ease-in-out_infinite]"
            />
            <path 
              d="M36 23.3102H45C49.4183 23.3102 53 26.8919 53 31.3102V45.3102C53 49.7285 49.4183 53.3102 45 53.3102H31C26.5817 53.3102 23 49.7285 23 45.3102V36.3102" 
              stroke="#37A4D3" 
              strokeOpacity="0.64" 
              strokeWidth="6" 
              strokeLinecap="round"
              className="animate-[pulse_1.5s_ease-in-out_infinite_0.3s]"
            />
            <path 
              d="M13 43.3102L43 13.3102" 
              stroke="#37A4D3" 
              strokeWidth="4" 
              strokeLinecap="round"
              className="animate-[pulse_1.5s_ease-in-out_infinite_0.6s]"
            />
          </svg>
          
          {/* Spinning ring around logo */}
          <div className="absolute inset-0 -m-2">
            <svg className="w-20 h-20 animate-spin" style={{ animationDuration: '2s' }} viewBox="0 0 80 80">
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="#37A4D3"
                strokeWidth="2"
                fill="none"
                strokeDasharray="60 140"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        {/* Loading text */}
        <div className="text-center">
          <p className="text-lg font-medium text-white">{message}</p>
          <p className="text-sm text-neutral-400 mt-1">Please wait...</p>
        </div>

        {/* Animated dots */}
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
